<div *ngIf="is_popup_visible" class="fixed top-0 left-0 z-40 flex items-center justify-center w-full h-full bg-black bg-opacity-70 backdrop-blur-sm p-4">
    <div class="bg-white rounded-xl max-h-[98%] w-[90%] md:w-[60%] lg:w-[55%] flex flex-col" [ngClass]="{'lg:w-[60%]': width == 'md','lg:w-[80%]': width == 'xl','lg:w-[100%]': width == 'lg','lg:w-auto': width == 'auto'}" [style.maxWidth]="max_width || null">
        <div class="sticky  bg-white flex flex-col p-4 rounded-xl ">
            <!-- Left Side Content -->
            <div class="flex justify-between items-center ">
                <h1 class="text-[20px] font-medium leading-none tracking-[0.02em] uppercase text-[#000000DE]"> {{ label }}</h1>
                <!-- Close Button -->
                <button (click)="close()" type="button" *ngIf="!is_mandatory" class="text-gray-400 hover:bg-gray-100 hover:text-gray-900 rounded-full w-8 h-8 flex justify-center items-center">
                    <i class="bx bx-x text-2xl"></i>
                    <span class="sr-only">Close</span>
                </button>
            </div>
            <!-- <p *ngIf="sub_label" class="text-base font-medium text-[#9C9C9C] "> {{ sub_label }}</p> -->
        </div>
        <div [ngClass]="{'overflow-auto max-h-[70vh]': scroll}" class="px-4 py-4 flex-1 min-h-0 flex flex-col justify-between w-full overflow-y-auto no-scrollbar">
            <ng-content></ng-content>
        </div>
    </div>
</div>